// extracted by mini-css-extract-plugin
export default {"login":"login_login__nRn4+"};